import ApiService from './ApiService'

export async function getTransaction(data) {
    return ApiService.fetchData({
        url: 'transaction/getTransaction',
        method: 'get',
        data
    })
}
export async function getTrsactionFlow(params) {
    return ApiService.fetchData({
        url: 'transaction/getTrsactionFlow',
        method: 'get',
        params // Axios will append this as query params automatically
    });
}
export async function getStatusesForEachTransaction(data) {
    return ApiService.fetchData({
        url: 'transaction/getStatusesForEachTransaction',
        method: 'get',
        data
    })
}
export async function apiSignIn(data) {
    return ApiService.fetchData({
        url: '/admin/sign-in',
        method: 'post',
        data
    })
}
export async function apiSendOtp(data) {
    return ApiService.fetchData({
        url: '/admin/send-otp',
        method: 'post',
        data
    })
}
export async function apiVarifyOtp(data) {
    return ApiService.fetchData({
        url: '/admin/varify-otp',
        method: 'post',
        data
    })
}
export async function apiregister(data) {
    return ApiService.fetchData({
        url: '/v2/user/update/Useragent-device',
        method: 'put',
        data
    })
}


export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function setSignOut(data) {
    return ApiService.fetchData({
        url: '/v2/customer/user/logout',
        method: 'put',
        data
    })
}


export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/user/send-reset-password',
        method: 'post',
        data
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/user/reset-password',
        method: 'put',
        data
    })
}

